import { render, staticRenderFns } from "./DocumentBreadCrumb.vue?vue&type=template&id=f4abe7f0&scoped=true"
import script from "./DocumentBreadCrumb.vue?vue&type=script&lang=js"
export * from "./DocumentBreadCrumb.vue?vue&type=script&lang=js"
import style0 from "./DocumentBreadCrumb.vue?vue&type=style&index=0&id=f4abe7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4abe7f0",
  null
  
)

export default component.exports